module.exports = __webpack_public_path__ + "static/media/Audio.f8e6fea3.svg";